import type { TypePublic } from '@/features/domaine/types/opco'
import type { EtablissementDTO } from './EtablissementDTO.ts'
import type { FacturationDTO } from './FacturationDTO.ts'
import { Financeur } from '@/features/domaine/types/opco/Remboursements'
import type { CodeHabilitation } from '@/features/api/extranet/dto/Dossier/Synthese/CodeHabilitation.ts'
import type { TypeFacturation } from '@/features/api/extranet/dto/Dossier/Synthese/TypeFacturation.ts'

export const RegroupementFraisNature = ['Pedagogique', 'Remuneration', 'Annexe', 'Divers'] as const
export type RegroupementFraisNature = typeof RegroupementFraisNature[number]
export const RegroupementFraisNatureLibelle: Record<RegroupementFraisNature, string> = {
  'Pedagogique': 'Pédagogiques',
  'Remuneration': 'Rémunération',
  'Annexe': 'Frais annexes',
  'Divers': 'Divers'
}


export type FactureBaseDTO = {
  type: TypeFacturation
  code: string
  reference: string | null
  source: string
  idSor: number
  dateReception: string | null
  dateEmission: string | null
  montantHt: number
  montantTTC: number
  etablissementEmetteur: EtablissementDTO | null
  typePublic: TypePublic
  financeur: Financeur
  facturation: FacturationDTO[]
  visibilite: CodeHabilitation[]
}
